import { 
  // Views
  Frontpage,
  NewsListing,
  TendersListing,
  
  // Blocks
  IconListingBlock,
  NewsListingBlock,
  PromosListingBlock,
  SliderListingBlock,

  // Widgets 
  AttachedImageWidget,
  DatetimeUTCWidget,
  IconSelectorWidget,
  ResultRenderer,
  SimpleColorPicker,
  RandomCheckboxWidget,

  // Icons
  ecityclicIconsList,
  brandsIconsList,
} from './components';

// Icons
import lastSVG from '@plone/volto/icons/news.svg';

// Widgets
import { UrlWidget } from '@plone/volto/components/manage/Widgets';

// Reducers
import reducers from './reducers';

// Cookies
import {
  defaultPanelConfig
} from './config';

const applyConfig = (config) => {
  // Language
  config.settings.isMultilingual = true;
  config.settings.defaultLanguage = 'ca';
  config.settings.supportedLanguages = ['es', 'ca'];

  // Navigation
  config.settings.navDepth = 2;

  // Opengraph image
  config.settings.contentMetadataTagsImageField = 'preview_image';

  // Hide tags
  config.settings.showTags = false;

  // Page size
  config.settings.defaultPageSize = 30;

  //Links
  config.settings.openLinkInNewTab = true;

  // Files in browser
  config.settings.downloadableObjects = [];
  config.settings.viewableInBrowserObjects = ['File'];

  // Allow to delete title block
  config.blocks.requiredBlocks = [];

  // Cookie Consent
  config.settings['volto-gdpr-privacy'] = {
    ...config.settings['volto-gdpr-privacy'],
    defaultPanelConfig: defaultPanelConfig,
  };

  // Reducers
  config.addonReducers = {
    ...config.addonReducers,
    ...reducers,
  };

  // Views
  config.views = {
    ...config.views,
    contentTypesViews: {
      ...config.views.contentTypesViews,
      LRF: Frontpage,
    },
    layoutViews: {
      ...config.views.layoutViews,
      tenders_listing_view: TendersListing,
      news_listing_view: NewsListing,
    },
    layoutViewsNamesMapping: {
      ...config.views.layoutViewsNamesMapping,
      tenders_listing_view: 'Tenders listing',
      news_listing_view: 'News listing'
    },
  };

  // Blocks
  config.blocks.groupBlocksOrder = [
    ...config.blocks.groupBlocksOrder,
    { id: 'proursa', title: 'PROURSA General' }
  ];

  // List variations
  config.blocks.blocksConfig.listing.showLinkMore = true;
  config.blocks.blocksConfig.listing.variations = [
    ...config.blocks.blocksConfig.listing.variations,
    { 
      id: 'icon',
      template: IconListingBlock,
      title: 'Icon',
    },
    { 
      id: 'news',
      template: NewsListingBlock,
      title: 'News',
    }, 
    { 
      id: 'promos',
      template: PromosListingBlock,
      title: 'Promos',
    }, 
    { 
      id: 'slider',
      template: SliderListingBlock,
      title: 'Slider',
    },
  ];

  // Widgets
  
  // Icon Selector
  config.widgets.widget.icon_selector = IconSelectorWidget;
  config.settings.widget.icon_selector = {
    ...config.settings.widget.icon_selector,
    iconList: {
      ...config.settings.widget.icon_selector.iconList,
      ecityclic: ecityclicIconsList,
      brands: brandsIconsList,
    },
    defaultRenderer: {
      ...config.settings.widget.icon_selector.defaultRenderer,
      ResultRenderer
    }
  }

  // Random CheckboxWidget
  config.widgets.widget.random_checkbox_widget = RandomCheckboxWidget

  config.widgets = {
    ...config.widgets,
    id: {
      ...config.widgets.id,
      content_icon: IconSelectorWidget,
      content_color: SimpleColorPicker ,
    },
  };

  config.settings.available_colors = [
    '#9E1F41',
    '#6A1A2F',
    '#3C3C3B',
    '#E9F8CA', 
    '#FFFFFF',
    '#F1F0ED'
  ];

  // Api Expanders
  config.settings.apiExpanders = [
    ...config.settings.apiExpanders,
    {
      match: '',
      GET_CONTENT: ['header_info'],
    },
  ];

  return config;
};

export default applyConfig;
